module.exports = __webpack_public_path__ + "media/images/flags/pn-54cde34167fa337e624b217d9e8846cc.svg";